import { render } from "./LabelCustom.vue?vue&type=template&id=5cda5ec6&scoped=true"
import script from "./LabelCustom.vue?vue&type=script&lang=js"
export * from "./LabelCustom.vue?vue&type=script&lang=js"

import "./LabelCustom.vue?vue&type=style&index=0&id=5cda5ec6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cda5ec6"]])

export default __exports__